import React from "react";
import { Helmet } from "react-helmet";
import { Typography, Row, Col, Button, Icon } from "antd";
import { index } from "../../utils/constants";
const { Text } = Typography;
const NotFound = () => (
    <div>
        <Helmet>
            <title>{`Page Not Found | MailChannels`}</title>
        </Helmet>
        <section
            style={{
                top: 0,
                position: "fixed",
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: 100,
                width: "100%",
                height: "100%",
            }}
        >
            <Row
                type="flex"
                justify="center"
                align="middle"
                style={{ height: "100%", textAlign: "center", fontSize: "1rem" }}
            >
                <Col>
                    <Text disabled style={{ fontSize: "7rem", display: "block" }}>
                        404
                    </Text>
                    <Text>{`Sorry, we can’t find the page you’re looking for.`}</Text>
                    <div style={{ margin: "1.5rem" }}>
                        <Button size="large" type="primary" href={index}>
                            <Icon type="left" />
                            {`Back to pricing page`}
                        </Button>
                    </div>
                </Col>
            </Row>
        </section>
    </div>
);

export default NotFound;
